export function interpolateLinks(text: string, urls: string[]): string {
  return urls.reduce((result, url, index) => {
    return result
      .replace(`<${index}>`, `<a href="${url}" target="_blank" rel="noopener noreferrer">`)
      .replace(`</${index}>`, '<span class="sr-only"> (opens in new window)</span></a>');
  }, text);
}



// WEBPACK FOOTER //
// ./ts/app/shared/helpers/interpolate-links.ts